// eslint-disable-next-line import/prefer-default-export
export const sortLabels = {
  global: {
    Sorting: {
      lbl_recommended: 'Recommended',
      lbl_min_offer_price_desc: 'Price: High to Low',
      lbl_min_offer_price_asc: 'Price: Low to High',
      lbl_newest_score: 'Newest',
      lbl_favoritedcount: 'Most Favorited',
      lbl_TCPBazaarVoiceRating: 'Top Rated',
    },
  },
};
